<!-- 点位列表 -->
<template>
    <div>
        <el-row class="bottom20">
            <el-table :data="tableData" stripe style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column
                        v-if="canSelected"
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column label="数据中心" v-if="true">
                    <template slot="header" slot-scope="scope">
                        数据中心<br>
                        <sysroom-select ref="sysroomRef" v-model="searchParams.roomId" size="mini"
                                        clearable></sysroom-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.roomId | roomFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="GUID" prop="guid">
                    <template slot="header" slot-scope="scope">
                        GUID<br>
                        <el-input size="mini" v-model="searchParams.like_guid"
                                  class="width70"></el-input>
                    </template>
                    <template slot-scope="scope">
                        <el-button @click="queryDetail(scope.row)" type="text" size="mini" class="width70">
                            {{scope.row.guid}}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="点位标签">
                    <template slot="header" slot-scope="scope">
                        点位标签<br>
                        <el-input size="mini" v-model="searchParams.like_code"
                                  class="width70"></el-input>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.code}}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="点位名">
                    <template slot="header" slot-scope="scope">
                        点位名<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.like_name"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="点位类型">
                    <template slot="header" slot-scope="scope">
                        点位类型<br>
                        <asset-attribute-select ref="pointTypeRef" v-model="searchParams.pointTypeId"
                                                :clazz="'width100'" :size="'mini'"></asset-attribute-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.pointTypeId | pointTypeFilter}}
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="描述">
                    <template slot="header" slot-scope="scope">
                        描述<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.like_description"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="realTimeValue" label="实时值">
                    <template slot="header" slot-scope="scope">
                        实时值<br><br><br>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>

    import DomainSelect from '@/components/domainaln'
    import point from '@/api/equipment/point/index'
    import {debounce, merge} from "@/util";
    import DomainaMixins from '@/mixins/domainaln';
    import PointEnum from './point-enum'
    import AssetAttributeSelect from '@/components/dcim/asset-attribute-select'
    import SysroomSelect from '@/components/sysroom'
    import AthubCloudApi from "@/api/athubCloud";

    let that;

    export default {
        name: "point-table.vue",

        mixins: [DomainaMixins, PointEnum],

        components: {
            DomainSelect,
            AssetAttributeSelect,
            SysroomSelect,
        },

        props: {
            canSelected: {
                type: Boolean,
                default: false,
            },
            search: {},
        },

        data() {
            return {
                authRoomIds: null,
                searchParams: {
                    roomId: null,
                    like_guid: '',
                    like_code: '',
                    like_name: '',
                    pointTypeId: '',
                    like_description: '',
                },

                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                total: 0,
                tableData: [],

                multipleSelection: [],
            }
        },

        mounted() {
            that = this;
            this.queryTable();
        },

        methods: {
            async getAuthRoomIds() {
                let roomIds = [];
                if (this.authRoomIds != null) {
                    roomIds = this.authRoomIds;
                } else {
                    roomIds = [];
                    let rooms = await AthubCloudApi.getRoomsByAuthSites();
                    for (let i = 0, len = rooms.length; i < len; i++) {
                        roomIds.push(rooms[i].id);
                    }
                    this.authRoomIds = roomIds;
                }
                return roomIds;
            },
            clearPageSearch() {
                this.currentPage = 1;
                this.pageSize = 10;
                this.searchParams = merge(true, {
                    roomId: null,
                    like_guid: '',
                    like_code: '',
                    like_name: '',
                    pointTypeId: '',
                    like_description: '',
                }, this.search);
            },
            async queryTable() {
                let pageSearch = {
                    current: this.currentPage,
                    size: this.pageSize,
                    search: this.searchParams,
                };
                if (pageSearch.search.roomId == null || String(pageSearch.search.roomId).trim() === '') {
                    pageSearch.search.in_roomId = await this.getAuthRoomIds(); // 默认数据中心
                }
                let pointPage = {total: 0, records: []};
                try {
                    let pointResponse = await point.page(pageSearch);
                    pointPage = pointResponse.data.data;
                    let guids = pointPage.records.map(e => e.guid == null ? '' : e.guid);
                    let rtvResponse = await point.getRealTimeValuesByGuids(guids);
                    for (let i = 0; i < pointPage.records.length; i++) {
                        pointPage.records[i].realTimeValue = rtvResponse.data[i];
                    }
                } catch (e) {
                    console.error(e);
                }
                this.tableData = pointPage.records;
                this.total = pointPage.total;
            },

            queryDetail(row) {
                this.$emit('queryDetail', row);
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            transferPointType(assetAttributes, value) {
                let desc = '';
                assetAttributes.forEach(e => {
                    if (e.assetattributeid == value) {
                        desc = e.assetattrid + '-' + e.description;
                        return;
                    }
                })
                return desc;
            },

        },

        filters: {
            pointTypeFilter(value) {
                return that.transferPointType(that.$refs['pointTypeRef'].assetAttributes, value) || '';
            },

            roomFilter(value) {
                let roomDesc = '';
                that.$refs['sysroomRef'].sysroomList.forEach(e => {
                    if (e.id == value) {
                        roomDesc = e.name;
                        return;
                    }
                })
                return roomDesc;
            },
        },

        watch: {
            search: {
                immediate: true,
                deep: true,
                handler() {
                    this.searchParams = merge(true, {}, this.searchParams, this.search);
                },
            },
            searchParams: {
                deep: true,
                handler: debounce(function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.queryTable();
                }, 500)
            },
        },

    }
</script>

<style scoped>

</style>
